﻿export const fontName = "sans-serif";
export const fontSize = "13px";
export const font = `normal ${fontSize} ${fontName}`;
